﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PinLocalizedTextUtils {
}
exports.PinLocalizedTextUtils = PinLocalizedTextUtils;
PinLocalizedTextUtils.getDefaultPinTexts = (translate) => {
    return ({
        pin: translate('PIN'),
        pinConfirmation: translate('PINConfirmation'),
        pinConfirmationError: translate('PINConfirmation_Error'),
        pinErrorMessage: translate('ErrorPIN')
    });
};
//# sourceMappingURL=PinLocalizedTextUtils.js.map